// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__1W_Z2","primarySection":"Layout_primarySection__a_48K","main":"Layout_main__3wxz8","opacity":"Layout_opacity__3UfTd"};